import './fancy-message-pane.scss';

export const FANCY_MESSAGE_PANE_NAME: string = 'fancyMessagePane';

export type FancyMessagePaneStatus = 'info' | 'warning' | 'danger' | 'success';
export type FancyMessagePaneState = {
  id: string;
  name: string;
  icon: string;
  status: FancyMessagePaneStatus;
};

export type FancyMessagePaneProps = {
  state?: FancyMessagePaneState;
  message?: string;
  float?: boolean;
  closeable?: boolean;
  onClose?: () => void;
};

export const FancyMessagePaneStates: {
  INFO: FancyMessagePaneState;
  WARN: FancyMessagePaneState;
  ERROR: FancyMessagePaneState;
  SUCCESS: FancyMessagePaneState;
} = {
  INFO: {
    id: 'info',
    name: 'Info',
    icon: 'icon-24-info-bold',
    status: 'info',
  },
  WARN: {
    id: 'warning',
    name: 'Warning',
    icon: 'icon-24-warning-bold',
    status: 'warning',
  },
  ERROR: {
    id: 'danger',
    name: 'Error',
    icon: 'icon-24-alert-bold',
    status: 'danger',
  },
  SUCCESS: {
    id: 'success',
    name: 'Success',
    icon: 'icon-24-success-bold',
    status: 'success',
  },
};

export class FancyMessagePaneController implements ng.IController, FancyMessagePaneProps {

}

export const FancyMessagePaneCreator: ng.IDirectiveFactory = (): ng.IDirective => {
  return {
    controllerAs: 'fancyMessagePane',
    controller: FancyMessagePaneController,
    bindToController: true,
    scope: {
      state: '<',
      message: '<',
      float: '<',
      closeable: '<',
      onClose: '&',
    },
    template: require('./fancy-message-pane.tpl.html'),
    transclude: false,
    link: ($scope: ng.IScope, $elem: JQLite, attrs: ng.IAttributes, ctrl?: ng.IController) => {
      $elem.addClass('fancy-message-pane-root');
    },
  };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/components/fancy-message-pane/fancy-message-pane.ts